import { AutogenModelEvent, AutogenRowEvent } from "./autogen/AutogenModelEvent";

export class ModelEvent extends AutogenModelEvent<RowEvent> {
	constructor() {
		super(RowEvent);
	}
}

export class RowEvent extends AutogenRowEvent {
}